/* tslint:disable */
/* eslint-disable */
/**
 * deliveryProviderPortal delivery-campaign-provider api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const AnalyticsEventName = {
        PROMOTIONS_SIGN_UP: 'promotion_sign_up',
        PROMOTION_SECTION_VISITED: 'promotion_section_visited',
        PROMOTION_CREATION_PAGE_VISITED: 'promotion_creation_page_visited'
} as const;
export type AnalyticsEventName = typeof AnalyticsEventName[keyof typeof AnalyticsEventName];

